'use client';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import { useEffect, useState } from 'react';
import { varAlpha } from 'minimal-shared/utils';
import { useAuthContext } from 'src/auth/hooks';
import { Logo } from 'src/components/logo';
import { RouterLink } from 'src/routes/components';
import { paths } from 'src/routes/paths';

export function Sidhuvud() {
    const { authenticated } = useAuthContext();
    const [scrollad, setScrollad] = useState(false);

    useEffect(() => {
        const kolla = () => setScrollad(window.scrollY > 8);
        kolla();
        window.addEventListener('scroll', kolla, { passive: true });
        return () => window.removeEventListener('scroll', kolla);
    }, []);

    return (
        <Box
            component="header"
            sx={(theme) => ({
                position: 'sticky',
                top: 0,
                zIndex: theme.zIndex.appBar,
                bgcolor: scrollad ? varAlpha(theme.vars.palette.background.defaultChannel, 0.86) : theme.vars.palette.background.default,
                backdropFilter: scrollad ? 'blur(8px)' : 'none',
                borderBottom: `1px solid ${scrollad ? theme.vars.palette.divider : 'transparent'}`,
                transition: theme.transitions.create(['background-color', 'border-color'])
            })}
        >
            <Container
                maxWidth="lg"
                sx={{ height: { xs: 64, md: 72 }, display: 'flex', alignItems: 'center', gap: 2 }}
            >
                <Logo href={paths.landning} sx={{ width: 88, height: 40 }} />

                <Box component="nav" aria-label="Sidans delar" sx={{ display: { xs: 'none', md: 'flex' }, gap: 0.5, ml: 3 }}>
                    <Button href="#demo" color="inherit" sx={{ fontWeight: 500 }}>
                        Demo
                    </Button>
                    <Button href="#kom-igang" color="inherit" sx={{ fontWeight: 500 }}>
                        Kom igång
                    </Button>
                    <Button component={RouterLink} href={paths.presentation.root} color="inherit" sx={{ fontWeight: 500 }}>
                        Presentationer
                    </Button>
                </Box>

                <Box sx={{ ml: 'auto', display: 'flex', gap: 1 }}>
                    {authenticated ? (
                        <Button component={RouterLink} href={paths.dashboard.root} variant="contained" color="primary">
                            Öppna Flinky
                        </Button>
                    ) : (
                        <>
                            <Button component={RouterLink} href={paths.LOGGA_IN} variant="outlined" color="inherit">
                                Logga in
                            </Button>
                            <Button
                                component={RouterLink}
                                href={paths.REGISTRERA}
                                variant="contained"
                                color="primary"
                                sx={{ display: { xs: 'none', sm: 'inline-flex' } }}
                            >
                                Skapa konto
                            </Button>
                        </>
                    )}
                </Box>
            </Container>
        </Box>
    );
}
